var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"solo":"","hide-details":"","placeholder":"Playthrough","prepend-inner-icon":"mdi-book-open-page-variant-outline","items":_vm.playthroughSteps,"value":_vm.value,"clearable":""},on:{"input":function($event){return _vm.select($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }